// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#peddler-bulk-upload[data-v-0fb481ab] {\n  top: 30%;\n  right: -25px;\n  min-width: 180px;\n  position: absolute;\n}\n.input-select-file[data-v-0fb481ab] {\n  width: 0px;\n  visibility: hidden;\n}\n.btn-primary[disabled=disabled][data-v-0fb481ab] {\n  color: #c1c1c1;\n  cursor: not-allowed;\n  border: 1px solid #c1c1c1;\n  background-color: #e5eaec90;\n}", ""]);
// Exports
module.exports = exports;
